module.exports = __webpack_public_path__ + "img/rw_arrange_letters.1d267eec.png";